import React, { useEffect } from 'react';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { PricingPage } from './pages/PricingPage';
import { ServicesPage } from './pages/ServicesPage';
import { WhoWeServePage } from './pages/WhoWeServePage';
import { ContactPage } from './pages/ContactPage';
import { BookingPage } from './pages/BookingPage';
import { ResourcesPage } from './pages/ResourcesPage';
// Utility component to scroll to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <HashRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="bg-white min-h-screen flex flex-col" data-id="element-2">
        <a href="#main-content" className="skip-link" data-id="element-3">
          Skip to main content
        </a>
        <Navbar data-id="element-4" />
        <main id="main-content" className="flex-grow" role="main" data-id="element-5">
          <Routes data-id="element-6">
            <Route path="/" element={<HomePage data-id="element-8" />} data-id="element-7" />
            <Route path="/about" element={<AboutPage data-id="element-10" />} data-id="element-9" />
            <Route path="/pricing" element={<PricingPage data-id="element-12" />} data-id="element-11" />
            <Route path="/services" element={<ServicesPage data-id="element-14" />} data-id="element-13" />
            <Route path="/who-we-serve" element={<WhoWeServePage data-id="element-16" />} data-id="element-15" />
            <Route path="/contact" element={<ContactPage data-id="element-18" />} data-id="element-17" />
            <Route path="/booking" element={<BookingPage data-id="element-20" />} data-id="element-19" />
            <Route path="/resources" element={<ResourcesPage data-id="element-22" />} data-id="element-21" />
          </Routes>
        </main>
        <Footer data-id="element-23" />
      </div>
    </HashRouter>;
}